import * as actionTypes from './quotesActionTypes';
import { QuotesStateModel } from './quotesStateModel';
import { mergeUpdateObj } from 'shared/shared.utilities';



export const initialCostsState: QuotesStateModel = {};


const quotesReducer = (state: QuotesStateModel = initialCostsState, action) => {
    switch (action.type) {
        case actionTypes.BUILD_QUOTE_SUCCESS:
            return mergeUpdateObj(state, { quotes: action.payload });
        case actionTypes.BUILD_QUOTE_FAILURE:
            return mergeUpdateObj(state, { quotesErrorMessage: action.payload });
        case actionTypes.FETCHING_QUOTES:
            return mergeUpdateObj(state, { fetchingQuotes: action.payload });
    }

    return state;
}



export default quotesReducer;